export function getTariffs(organizationId) {
    return axios.get('/api/organizations/' + organizationId + '/tariffs')
}

export function updateTariff(tariffId, data) {
    return axios.put(`/api/tariffs/${tariffId}`, data)
}
